import React, { useContext, useMemo } from "react";

import { noop } from "../../../../../../../Common/TypingUtils";
import { uuid } from "../../../../../../../Common/UUID";

export interface ICrossfitTableBodyEmptyRowRequester {
    requestEmptyRow(required: boolean): void;
}

export interface ICrossfitTableBodyRequestEmptyRowContext {
    requestEmptyRow(clientId: string, required: boolean): void;
}

export const CrossfitTableBodyRequestEmptyRowContext = React.createContext<ICrossfitTableBodyRequestEmptyRowContext>({
    requestEmptyRow: noop,
});

export function useCrossfitTableBodyRequestEmptyRowContext(): ICrossfitTableBodyEmptyRowRequester {
    const clientId = useMemo(() => uuid(), []);
    const context = useContext(CrossfitTableBodyRequestEmptyRowContext);

    return {
        requestEmptyRow: (required: boolean) => {
            context.requestEmptyRow(clientId, required);
        },
    };
}
